<template>
  <TransitionRoot as="template" :show="show">
    <Dialog as="div" class="fixed z-10 inset-0 overflow-y-auto" @click="showModal = false">
      <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
          <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </TransitionChild>

        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
        <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
          <div class="py-10 px-5 inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full">
            <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
              <div class="w-full block">
                <div class="w-full block mt-3 text-center sm:mt-0">
                  <DialogTitle as="h3" class="max-w-md m-auto text-2xl text-center leading-6 font-medium text-green-500">
                    {{ modalTranslation[language].cancel.title}}
                  </DialogTitle>
                  <div class="mt-4 text-center">
                    <div class="text-base text-green-500" v-if="subscription">
                       <p v-html="modalTranslation[language].cancel.subtitle( formatDate( subscription.subscription.renewalDate) )"></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse justify-center mt-10">
              <button type="button" class="w-full inline-flex justify-center rounded-md shadow-sm px-8 py-4 border-2 border-green-400 text-base font-medium hover:bg-green-400 focus:outline-none focus:ring-green-400 sm:ml-3 sm:w-auto hover:text-white" @click="onCancel" ref="cancelButtonRef">
                {{modalTranslation[language].cancel.buttonText}}
              </button>
              <button type="button" class="w-full inline-flex justify-center rounded-md shadow-sm px-8 py-4 border-2 border-blue-400 bg-blue-400
              text-white
               text-base font-medium hover:bg-blue-200 hover:border-blue-200 focus:outline-none  sm:ml-3 sm:w-auto hover:text-white" @click="closeModal" ref="cancelButtonRef">
                {{modalTranslation[language].cancel.buttonClose}}
              </button>
            </div>
          </div>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import { computed, ref } from 'vue'
import { Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { modalTranslation } from '@/translations/Modals.js'
import { useStore } from 'vuex'
import { dataLayerConfirmCancelSubscription } from '@/pixels/datalayer.js'

export default {
  components: {
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
  },
  setup( props, context ) {
    const showModal = ref(true)
    const store = useStore()
    const onCancel = async () => {
      dataLayerConfirmCancelSubscription()
      store.dispatch('cancelSubscription')

    }

    const closeModal= () => {
      context.emit('close')
    }

    const formatDate = ( date ) =>{
            const expire = new Date(date)
            const options = { year: 'numeric', month: 'long', day: 'numeric',  timeZone: "UTC"  };
            const lang = language.value  == 'es' ? 'es-ES' : 'en-US'

            return expire.toLocaleDateString(lang, options)
        }

    const language = computed( ()=> {
        return  localStorage.getItem('viva-translate') ? localStorage.getItem('viva-translate') : 'es';
    })

     const subscription =  computed( () => {
            return store.state.Checkout.data.userSubscription.data
        })

    return {
      showModal,onCancel,formatDate,subscription, modalTranslation, language, closeModal
    }
  },
}
</script>